import UIComponent from "../component";
import { Dropdown as BsDropdown } from "bootstrap";

export class Dropdown extends UIComponent {
    #cb = {
        onChange() {},
    }

    init() {
        this.on('click', this.handleClickOption.bind(this));

        new BsDropdown(this.find('[data-bs-toggle="dropdown"]'), {
            popperConfig: {
                placement: "top",
                modifiers: [
                    {
                        name: "flip",
                        options: {
                            padding: 8,
                            boundary: document.body,
                        }
                    },
                    {
                        name: "offset",
                        options: {
                            offset: [20, 20],
                        }
                    },
                ]
            }
        })
    }

    handleClickOption({ target }) {
        if (!target.hasAttribute('data-value')) return;

        this.changeActive(target);
    }

    changeActive(el) {
        for (let i = 0; i < this.option.length; i++) {
            const option = this.option[i];

            if (option.el() === el) {
                this.setActive(option);
                this.#cb.onChange(option.attr('data-value'));
                this.btn = option.text();
            } else {
                this.clearActive(option);
            }
        }
    }

    setActive(el) {
        el.addClass('active');
    }

    clearActive(el) {
        el.removeClass('active');
    }

    onChange(cb) {
        if (typeof cb !== 'function') return;

        this.#cb.onChange = cb;
    }
}
